<sepidz-review class="review list-wrapper">
  <div review-filters>
    <div>
      <section style="margin-top: 2px">
        <sepidz-static-select-review
          valueType="boolean"
          [form]="formGroup"
          [title]="'ClientApp.BackOffice.INV.InventoryReview.ShowLeftOnLine' | translate"
          name="ShowRunningTotal"
          key="ShowRunningTotal"
          [items]="[{ Name: translate('ClientApp.BackOffice.INV.InventoryReview.ShowLeftOnLine'), Value: true }]">
        </sepidz-static-select-review>
      </section>
      <section style="margin-top: 2px">
        <sepidz-static-select-review
          [form]="formGroup"
          valueType="boolean"
          [title]="'ClientApp.BackOffice.INV.InventoryReview.ShowBeginingOfTheCoursResidue' | translate"
          name="ShowBeginingOfTheCoursResidue"
          key="ShowBeginingOfTheCoursResidue"
          [items]="[{ Name: translate('ClientApp.BackOffice.INV.InventoryReview.ShowBeginingOfTheCoursResidue'), Value: true }]">
        </sepidz-static-select-review>
      </section>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('FilterInfo')">
          <span>{{ "ClientApp.BackOffice.INV.InventoryReview.FilterInfo" | translate }}</span>
          <i class="icon-chevron-right" [class.icon-chevron-up]="selected === 'FilterInfo'"></i>
        </div>
        <div *ngIf="selected === 'FilterInfo'">
          <section style="margin-top: 2px">
            <sepidz-static-select-review
              valueType="number"
              [form]="formGroup"
              [title]="'ClientApp.BackOffice.INV.InventoryReview.StartNumber' | translate"
              name="StartNumber"
              key="StartNumber"
              [items]="[{ Name: translate('ClientApp.BackOffice.INV.InventoryReview.StartNumber') }]">
            </sepidz-static-select-review>
          </section>
          <section style="margin-top: 2px">
            <sepidz-static-select-review
              valueType="number"
              [form]="formGroup"
              [title]="'ClientApp.BackOffice.INV.InventoryReview.EndNumber' | translate"
              name="EndNumber"
              key="EndNumber"
              [items]="[{ Name: translate('ClientApp.BackOffice.INV.InventoryReview.EndNumber') }]">
            </sepidz-static-select-review>
          </section>
          <section style="margin-top: 2px">
            <sepidz-static-select-review
              valueType="boolean"
              [form]="formGroup"
              [title]="'ClientApp.BackOffice.INV.InventoryReview.OnlySupplier' | translate"
              name="OnlySupplier"
              key="OnlySupplier"
              [items]="[{ Name: translate('ClientApp.BackOffice.INV.InventoryReview.OnlySupplier'), Value: false }]">
            </sepidz-static-select-review>
          </section>
          <section style="margin-top: 2px">
            <sepidz-static-select-review
              [form]="formGroup"
              valueType="boolean"
              [title]="'ClientApp.BackOffice.INV.InventoryReview.IsGoods' | translate"
              name="IsGoods"
              key="IsGoods"
              [items]="[{ Name: translate('ClientApp.BackOffice.INV.InventoryReview.IsGoods'), Value: false }]">
            </sepidz-static-select-review>
          </section>
          <section style="margin-top: 2px">
            <sepidz-static-select-review
              [form]="formGroup"
              valueType="boolean"
              [title]="'ClientApp.BackOffice.INV.InventoryReview.IsService' | translate"
              name="IsService"
              key="IsService"
              [items]="[{ Name: translate('ClientApp.BackOffice.INV.InventoryReview.IsService'), Value: false }]">
            </sepidz-static-select-review>
          </section>
          <section style="margin-top: 5px">
            <sepidz-static-select-review
              valueType="number"
              [form]="formGroup"
              [title]="'ClientApp.BackOffice.INV.InventoryReview.SlaveNo' | translate"
              name="SlaveNo"
              key="SlaveNo"
              [items]="[{ Name: translate('ClientApp.BackOffice.INV.InventoryReview.SlaveNo') }]">
            </sepidz-static-select-review>
          </section>
          <section style="margin-top: 2px">
            <sepidz-static-select-review
              valueType="text"
              [form]="formGroup"
              [title]="'ClientApp.BackOffice.INV.InventoryReview.TraceElement' | translate"
              name="TraceElement"
              key="TraceElement"
              [items]="[{ Name: translate('ClientApp.BackOffice.INV.InventoryReview.TraceElement'), Value: '' }]">
            </sepidz-static-select-review>
          </section>
          <section style="margin-top: 2px">
            <sepidz-static-select-review
              valueType="date"
              [form]="formGroup"
              [title]="'ClientApp.BackOffice.INV.InventoryReview.ReceiptDate' | translate"
              name="ReceiptDate"
              key="ReceiptDate"
              [items]="[{ Name: translate('ClientApp.BackOffice.INV.InventoryReview.ReceiptDate'), Value: '' }]">
            </sepidz-static-select-review>
          </section>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('StatusKindTitle')">
          <span>{{ "ClientApp.BackOffice.INV.StatusKind.StatusKindTitle" | translate }}</span>
          <i class="icon-chevron-right" [class.icon-chevron-up]="selected === 'StatusKindTitle'"></i>
        </div>
        <div *ngIf="selected === 'StatusKindTitle'">
          <sepidz-remote-select-review
            [title]="'ClientApp.BackOffice.INV.StatusKind.StatusKindTitle' | translate"
            [form]="formGroup"
            name="StatusKind"
            key="StatusKindIds"
            apiName="Lookup"
            systemName="INV"
            category="StatusKind">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('Branch')">
          <span>{{ "ClientApp.BackOffice.INV.InventoryReview.Branch" | translate }}</span>
          <i class="icon-chevron-right" [class.icon-chevron-up]="selected === 'Branch'"></i>
        </div>
        <div *ngIf="selected === 'Branch'">
          <sepidz-remote-select-review
            [title]="'ClientApp.BackOffice.INV.InventoryReview.Branch' | translate"
            [form]="formGroup"
            name="Branch"
            key="BranchIds"
            apiName="Branch/ReadLookUp">
          </sepidz-remote-select-review>
        </div>
      </div>
    </div>
  </div>
  <div review-content>
    <ssg-tabset class="tabset" (tabChange)="selectTab($event)">
      <ssg-tab
        *hasPermission="['Inventory:InventoryReview/GetInvVoucherKind', 'Same']"
        [tabTitle]="'ClientApp.BackOffice.INV.InventoryReview.InvVoucherKind' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.INV.InventoryReview.InvVoucherKind' | translate)"
          name="InvVoucherKindId"
          [title]="'ClientApp.BackOffice.INV.InventoryReview.InvVoucherKind' | translate"
          apiName="InventoryReview/GetInvVoucherKind"
          areaName="Inventory"
          [groupable]="false"
          [columns]="GetInvVoucherKindColumns"
          [filtering]="true"
          pathPreFix="INV"
          displayNameColumn="VoucherKindTitle"
          key="InvVoucherKindIds">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab
        *hasPermission="['Inventory:InventoryReview/GetInvSupplier', 'Same']"
        [tabTitle]="'ClientApp.BackOffice.INV.InventoryReview.InvSupplier' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.INV.InventoryReview.InvSupplier' | translate)"
          name="DetailLedgerId"
          [title]="'ClientApp.BackOffice.INV.InventoryReview.InvSupplier' | translate"
          apiName="InventoryReview/GetInvSupplier"
          areaName="Inventory"
          [groupable]="false"
          [columns]="GetDetailLedgerColumns"
          [filtering]="true"
          pathPreFix="INV"
          displayNameColumn="DetailLedgerCode"
          key="DetailLedgerIds">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab
        *hasPermission="['Inventory:InventoryReview/GetWarehouse', 'Same']"
        [tabTitle]="'ClientApp.BackOffice.INV.InventoryReview.Warehouse' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.INV.InventoryReview.Warehouse' | translate)"
          name="WarehouseiD"
          [title]="'ClientApp.BackOffice.INV.InventoryReview.Warehouse' | translate"
          apiName="InventoryReview/GetWarehouse"
          areaName="Inventory"
          [columns]="GetWarehouseColumns"
          [filtering]="true"
          pathPreFix="INV"
          displayNameColumn="WarehouseTitle"
          key="WarehouseIds">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab
        *hasPermission="['Inventory:InventoryReview/GetGoodsGroup', 'Same']"
        [tabTitle]="'ClientApp.BackOffice.INV.InventoryReview.GoodsGroup' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.INV.InventoryReview.GoodsGroup' | translate)"
          name="GoodsGroupId"
          [title]="'ClientApp.BackOffice.INV.InventoryReview.GoodsGroup' | translate"
          apiName="InventoryReview/GetGoodsGroup"
          areaName="Inventory"
          [columns]="GetGoodsGroupColumns"
          [filtering]="true"
          [groupable]="false"
          pathPreFix="INV"
          displayNameColumn="GoodsGroupTitle"
          key="GoodsGroupIds">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab
        *hasPermission="['Inventory:InventoryReview/GetGoods', 'Same']"
        [tabTitle]="'ClientApp.BackOffice.INV.InventoryReview.Goods' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.INV.InventoryReview.Goods' | translate)"
          name="GoodsId"
          [title]="'ClientApp.BackOffice.INV.InventoryReview.Goods' | translate"
          apiName="InventoryReview/GetGoods"
          areaName="Inventory"
          [columns]="GetGoodsColumns"
          [filtering]="true"
          [groupable]="true"
          pathPreFix="INV"
          displayNameColumn="GoodsTitle"
          key="GoodsIds">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab
        *hasPermission="['Inventory:InventoryReview/GetVoucherHeader', 'Same']"
        [tabTitle]="'ClientApp.BackOffice.INV.InventoryReview.VoucherHeader' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.INV.InventoryReview.VoucherHeader' | translate)"
          name="InvVoucherHeaderId"
          [title]="'ClientApp.BackOffice.INV.InventoryReview.VoucherHeader' | translate"
          apiName="InventoryReview/GetVoucherHeader"
          areaName="Inventory"
          [columns]="GetVoucherHeaderColumns"
          [filtering]="false"
          [groupable]="true"
          pathPreFix="INV"
          displayNameColumn="VoucherNo"
          key="VoucherHeaderIds">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab
        *hasPermission="['Inventory:InventoryReview/GetVoucherDetail', 'Same']"
        [tabTitle]="'ClientApp.BackOffice.INV.InventoryReview.VoucherDetail' | translate">
        <sepidz-grid-review
          *ngIf="
            isActveTab('ClientApp.BackOffice.INV.InventoryReview.VoucherDetail' | translate) &&
            GetVoucherDetailColumns &&
            GetVoucherDetailColumns.length > 0
          "
          name="VoucherDetail"
          [title]="'ClientApp.BackOffice.INV.InventoryReview.VoucherDetail' | translate"
          apiName="InventoryReview/GetVoucherDetail"
          areaName="Inventory"
          [columns]="GetVoucherDetailColumns"
          [selective]="false"
          [filtering]="true"
          [isModal]="false"
          defaultSortKey="VoucherDate"
          pathPreFix="INV"
          [actionTregger]="onActionClick"
          [actions]="actions"
          key="VoucherDetailIds">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab
        *hasPermission="['Inventory:InventoryReview/GetGoodsCardAmount', 'Same']"
        [tabTitle]="'ClientApp.BackOffice.INV.InventoryReview.GoodsCardAmount' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.INV.InventoryReview.GoodsCardAmount' | translate)"
          name="GoodsCardAmount"
          [title]="'ClientApp.BackOffice.INV.InventoryReview.GoodsCardAmount' | translate"
          apiName="InventoryReview/GetGoodsCardAmount"
          areaName="Inventory"
          [columns]="GetGoodsCardAmountColumns"
          [selective]="false"
          [filtering]="false"
          [groupable]="true"
          pathPreFix="INV"
          key="GoodsCardAmountIds">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab
        *hasPermission="['Inventory:InventoryReview/GetGoodsCardPrice', 'Same']"
        [tabTitle]="'ClientApp.BackOffice.INV.InventoryReview.GoodsCardPrice' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.INV.InventoryReview.GoodsCardPrice' | translate)"
          name="GoodsCardPrice"
          [title]="'ClientApp.BackOffice.INV.InventoryReview.GoodsCardPrice' | translate"
          apiName="InventoryReview/GetGoodsCardPrice"
          areaName="Inventory"
          [columns]="GetGoodsCardPriceColumns"
          [selective]="false"
          [filtering]="false"
          [groupable]="true"
          pathPreFix="INV"
          key="GoodsCardPriceIds">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab
        *hasPermission="['Inventory:InventoryReview/GoodsFormulaReport', 'Same']"
        [tabTitle]="'ClientApp.BackOffice.INV.InventoryReview.GoodsFormulaReport' | translate">
        <sepidz-grid-review
          *ngIf="
            isActveTab('ClientApp.BackOffice.INV.InventoryReview.GoodsFormulaReport' | translate) &&
            GetGoodsFormulaColumns &&
            GetGoodsFormulaColumns.length > 0
          "
          name="GoodsFormulaReport"
          [title]="'ClientApp.BackOffice.INV.InventoryReview.GoodsFormulaReport' | translate"
          apiName="InventoryReview/GoodsFormulaReport"
          areaName="Inventory"
          [columns]="GetGoodsFormulaColumns"
          [selective]="false"
          [filtering]="false"
          [groupable]="true"
          pathPreFix="INV">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab
        *hasPermission="['Inventory:InventoryReview/GetVoucherGoodsWarehouseDetail', 'Same']"
        [tabTitle]="'ClientApp.BackOffice.INV.InventoryReview.VoucherGoodsWarehouseReport' | translate">
        <sepidz-grid-review
          *ngIf="
            isActveTab('ClientApp.BackOffice.INV.InventoryReview.VoucherGoodsWarehouseReport' | translate) &&
            GetVoucherDetailColumns &&
            GetVoucherDetailColumns.length > 0
          "
          name="VoucherGoodsWarehouseReport"
          [title]="'ClientApp.BackOffice.INV.InventoryReview.VoucherGoodsWarehouseReport' | translate"
          apiName="InventoryReview/GetVoucherGoodsWarehouseDetail"
          areaName="Inventory"
          [columns]="GetVoucherDetailColumns"
          [selective]="false"
          [filtering]="false"
          [groupable]="true"
          pathPreFix="INV">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab
        *hasPermission="['Inventory:InventoryReview/GetProductConsumptionReport', 'Same']"
        [tabTitle]="'ClientApp.BackOffice.INV.InventoryReview.ProductConsumptionReport' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.INV.InventoryReview.ProductConsumptionReport' | translate)"
          name="GetProductConsumptionReport"
          [title]="'ClientApp.BackOffice.INV.InventoryReview.ProductConsumptionReport' | translate"
          apiName="InventoryReview/GetProductConsumptionReport"
          areaName="Inventory"
          [columns]="GetProductConsumptionReport"
          [filtering]="true"
          pathPreFix="INV">
        </sepidz-grid-review>
      </ssg-tab>
    </ssg-tabset>
  </div>
</sepidz-review>
